import { format } from "date-fns";
import {
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    LineChart,
    Line,
} from "recharts";
import styled from "styled-components";
import { useUserActive } from "../../../hooks/dashboard/useUserActive";
import { useEffect, useState } from "react";
import { Title } from "melco-ui";
import { useAllProducts } from "../../../hooks/useAllProduts";
import { PRODUCT_GRAPH_COLOR } from "../../../helper/dashboardHelper";

const ChartWrapper = styled.div`
 
  max-width:500px;
  margin-top:30px;
  margin-bottom:30px;
  margin-left:15px;
  margin-right:15px;
  max-height:300px;
  
`;


type ActiveUsersChartProps = {
    startTimestamp?: Date;
    endTimestamp?: Date;
    selectedProductCode?: string;
};

export const ActiveUsersChart: React.FC<ActiveUsersChartProps> = ({
    startTimestamp,
    endTimestamp,
    selectedProductCode
}) => {

    const { products } = useAllProducts();
    const [chartData, setChartData] = useState();
    const [productsWithColorCodeJsonArray, setProductsWithColorCodeJsonArray] = useState();
    useEffect(() => {
        let arr: any = {};
        products.map((product) => {
            if (product && product.code) {
                arr[product.code] = {
                    product_code: product.code,
                    product_name: product.name,
                    product_graph_color: PRODUCT_GRAPH_COLOR[product.code]
                }
            }

        })

        setProductsWithColorCodeJsonArray(arr)
    }, [products])

    const getUserData = useUserActive(startTimestamp, endTimestamp, selectedProductCode);


    const makeChartData = (data: any) => {
        let result: any = {}

        data.forEach((item: any) => { //1
            Object.keys(item).forEach(function (key) { //2
                let date = format(item.created_date, "MMM dd")
                // let date = new Intl.DateTimeFormat(navigator.language).format(item.created_date)
                if (!result[date]) result[date] = {}; //3

                else {
                    // console.log(item.product_code);
                    // console.log(productsWithColorCodeJsonArray)
                    //  console.log(productsWithColorCodeJsonArray?.[item.product_code])     ;
                    if (productsWithColorCodeJsonArray && item?.product_code)
                        result[date][productsWithColorCodeJsonArray?.[item.product_code]?.["product_name"]] = item.active_users;
                }
            });
        })


        let arrayResult: any = []
        Object.keys(result).forEach((key: any) => {
            let temp = result[key];
            temp["Date"] = key;
            arrayResult.push(temp)
        });
        //  console.log(arrayResult)
        return arrayResult;
    }


    useEffect(() => {

        const fn = async () => {
            const response = await getUserData()
            let chartData = makeChartData(response?.list);
            //console.log(chartData)
            setChartData(chartData)
        }
        if (startTimestamp && endTimestamp)
            fn();
    }, [productsWithColorCodeJsonArray, startTimestamp, endTimestamp, selectedProductCode])

    //  console.log(calculateActiveusersPerMonth([]))
    return (
        <>
            <ChartWrapper >
                <ResponsiveContainer>
                    <>
                        <Title level={5}>Active Users </Title>
                        <LineChart

                            width={500}
                            height={300}
                            data={chartData}
                            margin={{
                                top: 0,
                                right: 0,
                                left: 0,
                                bottom: 0,
                            }}


                        >

                            <CartesianGrid strokeDasharray="5 5" />
                            <XAxis dataKey="Date" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            {
                                productsWithColorCodeJsonArray && Object.keys(productsWithColorCodeJsonArray).map((p) => {
                                    return ((selectedProductCode == undefined || selectedProductCode == productsWithColorCodeJsonArray[p]["product_code"]) && <Line type="monotone" dataKey={productsWithColorCodeJsonArray[p]["product_name"]} stroke={productsWithColorCodeJsonArray[p]["product_graph_color"]} />)
                                    //console.log(productsWithColorCodeJsonArray[p]["product_name"]);
                                    //console.log(productsWithColorCodeJsonArray[p]["product_graph_color"])
                                })
                            }
                        </LineChart>
                    </>
                </ResponsiveContainer>
            </ChartWrapper>

        </>);
};
